module.exports = __webpack_public_path__ + "static/media/trinket.9ca4864b.png";